module.exports = __webpack_public_path__ + "assets/img/jq.4ef5d12d.png";